import { useMemo } from 'react'
import { useIntl } from 'react-intl'

function useEsimBenefitTileMessages(gbValue: number) {
  const intl = useIntl()

  return useMemo(() => ({
    heading: intl.formatMessage(
      {
        id: 'Twf9q4A3YldgMqUZWnff',
        defaultMessage: 'Free {gbValue}GB travel eSIM',
        description: 'Heading text for the eSIM benefit tile on the order view page',
      },
      { gbValue },
    ),
    description: intl.formatMessage(
      {
        id: '7Zgk-vGnD13W8DUw7MXF',
        defaultMessage: 'Stay connected on every international trip with {gbValue}GB of complimentary mobile data.',
        description: 'Description text for the eSIM benefit tile on the order view page',
      },
      { gbValue },
    ),
    addedLabel: intl.formatMessage({
      id: 'RioreOBROGNRKdkgS55A',
      defaultMessage: 'Added',
      description: 'Status label indicating the eSIM benefit is included in the booking',
    }),
    detailsLabel: intl.formatMessage({
      id: 'IuiqtRmg4WQOcjfjB7cn',
      defaultMessage: 'Details',
      description: 'Button label to open the eSIM benefit details modal from tile',
    }),
  }), [intl, gbValue])
}

export default useEsimBenefitTileMessages
